// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminologyLibraryResponseItemsInner
 */
export interface TerminologyLibraryResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    extensible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    submission_value?: string;
    /**
     * 
     * @type {number}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    value_count?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof TerminologyLibraryResponseItemsInner
     */
    values_preview?: Array<object>;
}

/**
 * Check if a given object implements the TerminologyLibraryResponseItemsInner interface.
 */
export function instanceOfTerminologyLibraryResponseItemsInner(value: object): value is TerminologyLibraryResponseItemsInner {
    return true;
}

export function TerminologyLibraryResponseItemsInnerFromJSON(json: any): TerminologyLibraryResponseItemsInner {
    return TerminologyLibraryResponseItemsInnerFromJSONTyped(json, false);
}

export function TerminologyLibraryResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminologyLibraryResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'extensible': json['extensible'] == null ? undefined : json['extensible'],
        'name': json['name'] == null ? undefined : json['name'],
        'submission_value': json['submission_value'] == null ? undefined : json['submission_value'],
        'value_count': json['value_count'] == null ? undefined : json['value_count'],
        'values_preview': json['values_preview'] == null ? undefined : json['values_preview'],
    };
}

export function TerminologyLibraryResponseItemsInnerToJSON(json: any): TerminologyLibraryResponseItemsInner {
    return TerminologyLibraryResponseItemsInnerToJSONTyped(json, false);
}

export function TerminologyLibraryResponseItemsInnerToJSONTyped(value?: TerminologyLibraryResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'extensible': value['extensible'],
        'name': value['name'],
        'submission_value': value['submission_value'],
        'value_count': value['value_count'],
        'values_preview': value['values_preview'],
    };
}
